import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import { openSubMenuAndToggleUI, keyboardEnterOrSpaceClick } from "../../utils";
import { SecondaryNavLink } from "./index";

//Render secondary navigation link with sub navigation
const SecondaryNavWithSubNav = ({
  menu,
  isSmall,
  isIntermediate,
  toggleSecondary,
  setToggleSecondary,
  openSecondarySubMenu,
  setIsMainMenuCollapsed,
  setShowSubMenu,
}) => {
  const analytics = useAnalytics();

  return (
    <span
      role="button"
      onClick={(event) => {
        openSubMenuAndToggleUI(
          isSmall,
          setToggleSecondary,
          toggleSecondary,
          openSecondarySubMenu,
          menu,
          event,
          isIntermediate,
          setIsMainMenuCollapsed,
          setShowSubMenu,
        );

        analytics.track(trackingConst.events.buttonClicked, {
          id: menu.id,
          name: trackingConst.names.navigationToggled,
          context: trackingConst.contexts.appshell,
        });
      }}
      onKeyDown={(event) => {
        keyboardEnterOrSpaceClick(event, () =>
          openSubMenuAndToggleUI(
            isSmall,
            setToggleSecondary,
            toggleSecondary,
            openSecondarySubMenu,
            menu,
            event,
            isIntermediate,
            setIsMainMenuCollapsed,
            setShowSubMenu,
          ),
        );

        analytics.track(trackingConst.events.buttonClicked, {
          id: menu.id,
          name: trackingConst.names.navigationToggled,
          context: trackingConst.contexts.appshell,
        });
      }}
      tabIndex={0}
      data-testid={`${menu.id}_open_sub`}
    >
      <SecondaryNavLink menu={menu} isSmall={isSmall} toggleSecondary={toggleSecondary} />
    </span>
  );
};

export default SecondaryNavWithSubNav;
